export default __webpack_public_path__ + "static/media/logotype_white_bluebg.f6021c31.svg";